<template>
  <button
    :class="combinedClass"
    class="btn-status font-normal"
    :disabled="disabled"
    :style="style"
    @click="clickMe"
  >
    {{ status }}
  </button>
</template>

<script>
export default {
  name: 'StatusButton',
  props: {
    value: {
      type: String,
      default: 'accepted',
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    size: String,
    class: String,
    style: Object,
  },
  emits: ['click'],
  computed: {
    buttonSize() {
      switch (this.size) {
        case 'xs':
          return 'btn-size-xs';
        case 'md':
          return 'btn-size-md';
        default:
          return '';
      }
    },
    status() {
      switch (this.value) {
        case 'claimed':
          return 'Accepted';
        default:
          return 'Pending';
      }
    },
    combinedClass() {
      return (
        this.status.toLowerCase() + ' ' + this.class + ' ' + this.buttonSize
      );
    },
  },
  methods: {
    clickMe() {
      this.$emit('click');
    },
    getInvitationStatusText(status) {
      switch (status) {
        case 'claimed':
          return 'Accepted';
        default:
          return 'Pending';
      }
    },
  },
};
</script>
<style scoped>
button:disabled {
  @apply rounded-3xl border-0;
}

.accepted {
  @apply w-full bg-light-green p-4 text-xs text-green-500;
}

.accepted:disabled {
  @apply cursor-default bg-light-green !important;
}

.pending {
  @apply w-full bg-light-gray p-4 text-xs text-body-color;
}

.pending:disabled {
  @apply cursor-default bg-light-gray !important;
}

.btn-size-xs {
  @apply w-auto p-1 text-xxs !important;
}

.btn-size-md {
  @apply w-auto p-2 !important;
}

.btn-status {
  padding: 4px 8px !important;
}
</style>
